<template>
  <div>
    <v-dialog v-model="installmentDialog" width="850" @input="closeDialog">
      <v-form ref="form"  v-on:submit.prevent>
        <v-card>
          <v-card-text class="border-bottom">
            <div class="row pt-1 border-bottom">
              <div class="col-md-12">
                <div class="d-flex justify-space-between align-center mt-2">
                  <SvgIcon class="text-2xl font-semibold" text="Deals Installments" style="color: black">
                  </SvgIcon>
                  <v-btn fab x-small class="shadow-0" @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
            <v-row dense class="mt-4">
              <div class="col-md-12">
                <div class="table-responsive">
                  <table class="table border-collapse">
                    <thead>
                    <tr class="opacity-70 tr-neon tr-rounded ">
                      <th>
                        <div class="md-table-head-container md-ripple md-disabled">
                          <div class="md-table-head-label">No</div>
                        </div>
                      </th>
                      <th>
                        <div class="md-table-head-container md-ripple md-disabled">
                          <div class="md-table-head-label">Amount</div>
                        </div>
                      </th>
                      <th>
                        <div class="md-table-head-container md-ripple md-disabled">
                          <div class="md-table-head-label">Date</div>
                        </div>
                      </th>
                      <th>
                        <div class="md-table-head-container md-ripple md-disabled">
                          <div class="md-table-head-label">Invoice</div>
                        </div>
                      </th>
                      <th>
                        <div class="md-table-head-container md-ripple md-disabled">
                          <div class="md-table-head-label">Status</div>
                        </div>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(data, index) in installments" :key="index" class="border-bottom text-center">
                      <td>
                        <div>
                          {{ index+1 }}
                        </div>
                      </td>
                      <td>
                        <div >
                          {{ data.value_of_installment | toCurrency}}
                        </div>
                      </td>
                      <td>
                        <div :class="new Date(data.installment_date) <  new Date() ? 'red--text':''">
                          {{ data.installment_date | dateformat }}
                        </div>
                      </td>
                      <td>
                        <div>
                          <v-file-input
                              class="q-text-field file-input"
                              dense
                              hide-details="auto"
                              outlined
                              @click:clear="onFileClear(data)"

                              prepend-icon=""
                              @change="handleInstallmentAction($event,data,'upload')"
                          >
                            <p class="file-chip mb-0">
                              File
                            </p>
                            <template #prepend-inner>
                              <SvgIcon>
                                <template #icon>
                                  <FileIcon/>
                                </template>
                              </SvgIcon>
                            </template>
                          </v-file-input>
                          <a v-if="data.invoice" :href="s3BucketURL+data.invoice" class="text-black mt-2 d-block w-fit" target="_blank">
                            <p class="file-chip mb-0">
                              {{data.invoice.slice(-15)}}
                            </p>
                          </a>
                        </div>
                      </td>


                      <td>
                        <div class="d-flex gap-x-2 justify-center align-center" @click="handleInstallmentAction(null,data,'statusChange')">
                          <v-btn
                              style=""
                              class="download-button text_capitalize "
                              outlined
                          >{{data.status_id == 4? "Paid":"Unpaid"}}</v-btn>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color=" "
                class="ma-2  "
                text
                @click="closeDialog"
            > Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>


import SvgIcon from "@/components/Image/SvgIcon.vue";
import FileIcon from "@/assets/images/venues/file.svg";


export default {
  components: {
    FileIcon,
    SvgIcon,
  },
  props: {
    dealId: {type: Number, default: null},
    installmentDialog: {type: Boolean, default: false},

  },
  watch: {

  },
  mounted() {
    this.getDealInstallments(this.dealId)
  },


  computed: {

  },
  data() {
    return {
      installments:[],
    };
  },
  methods: {
    closeDialog() {
      this.$emit('closeInstallmentPopup')
    },

    getDealInstallments(dealId){
      this.showLoader('Loading installment')
      this.$http({
        url: `sales-team/deals/installments/${dealId}`,
        method: "GET",
        data: {},
      })
          .then((response) => {
            if (response.status === 200) {
             this.installments = response.data.data;
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          })
          .finally(() => {
            this.hideLoader();
          });
    },
    onFileClear(installment){
      this.handleInstallmentAction(null,installment,'deleteInvoice')
    },


    handleInstallmentAction(e, installment, actionType) {
      if(actionType === "upload" && !e){
        return;
      }
      this.showLoader(actionType === 'upload' ? "Uploading Invoice" : "Saving Data");
      let formData = new FormData();
      formData.set("deal_id", installment.qp_deal_id);
      if (actionType === 'upload' && e) {
        formData.set("invoice", e);
      } else if (actionType === 'statusChange') {
        let status = installment.status_id == 4 ? 5 : 4;
        formData.set("installment_status", status);
      }else if (actionType === 'deleteInvoice') {
        formData.set("deleteInvoice", 1);
      }

      this.$http({
        url: `sales-team/deals/installment/${installment.id}`,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data; boundary=${form._boundary}",
        },
      })
          .then((response) => {
            if (response.status === 200) {
              if (actionType === 'upload') {
                installment.invoice = response.data.data.invoice;
                this.showSuccess("Invoice Added Successfully.");
              }if (actionType === 'deleteInvoice') {
                installment.invoice = response.data.data.invoice;
                this.showSuccess("Invoice Deleted Successfully.");
              } else if (actionType === 'statusChange') {
                installment.status_id = response.data.data.status_id;
                this.showSuccess("Status Updated Successfully.");
              }
            }
          })
          .catch((error) => {
            this.errorChecker(error);
          })
          .finally(() => {
            this.hideLoader();
          });
    },


  }
}
</script>

<style scoped>
.banner-text {
  background: rgba(232, 241, 244, 0.7);
  color: black;
  padding: 10px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

}
</style>